var consts = {
  MainUrl: "https://admin.tajirexchange.com/",
  BackendUrl: "https://backend.tajirexchange.com/tajirex",
  FrondEndUrl: "https://admin.tajirexchange.com/tajirex/",
  FrondEndUrl: "https://exchange.tajirexchange.com/",
  socketUrl: 'https://backend.tajirexchange.com',
  // For Local

  route: "tajirex",

  // MainPair: "BTC_USDT",
  // MainUrl: "http://localhost:3500",
  // BackendUrl: "http://localhost:3500/tajirex",
  // socketUrl: 'http://localhost:3500',
  // FrondEndUrl: "http://localhost:3000",

}
export default consts;
